/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_No_OutputInputs */

const es_chat_tool_detail_no_output = /** @type {(inputs: Chat_Tool_Detail_No_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin resultado disponible`)
};

const en_chat_tool_detail_no_output = /** @type {(inputs: Chat_Tool_Detail_No_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No result available`)
};

/**
* | output |
* | --- |
* | "No result available" |
*
* @param {Chat_Tool_Detail_No_OutputInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_no_output = /** @type {((inputs?: Chat_Tool_Detail_No_OutputInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_No_OutputInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_no_output(inputs)
	return en_chat_tool_detail_no_output(inputs)
});
export { chat_tool_detail_no_output as "chat.tool_detail.no_output" }